import { render, staticRenderFns } from "./RegionCard.vue?vue&type=template&id=13c9edeb"
import script from "./RegionCard.vue?vue&type=script&lang=js"
export * from "./RegionCard.vue?vue&type=script&lang=js"
import style0 from "./RegionCard.vue?vue&type=style&index=0&id=13c9edeb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports